module.exports = __webpack_public_path__ + "static/taca-03f52569ae77488bb6628804f4ae9820.png";